import {Component, inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NZ_MODAL_DATA, NzModalRef} from 'ng-zorro-antd/modal';
import {EventManager, IUser, User, UserService} from '../../../core';
import {ActivatedRoute, Router} from '@angular/router';
import { ModalComponent } from '../../../shared/components/modal.component';

@Component({
  selector: 'app-members-update',
  templateUrl: './members-update.component.html',
  styleUrls: ['./members-update.component.scss']
})
export class MembersUpdateComponent extends ModalComponent implements OnInit {
  btnLabel = 'Save';
  @Input() user!: User;
  newUser: User;
  errorMessage: string;
  authorities: string[] = [];
  isSaving = false;
  isConfirmLoading = false;
  userForm: FormGroup;
  selectedAuthority: string;
  readonly nzModalData: any = inject(NZ_MODAL_DATA);
  constructor(
    private fb: FormBuilder,
    private modal: NzModalRef,
    private userService: UserService,
    public eventManager: EventManager,
  ) {
    super(eventManager);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.errorMessage = '';
    this.userForm = this.fb.group({
      id: [],
      login: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(50), Validators.pattern('^[_.@A-Za-z0-9-]*')]],
      firstName: ['', [Validators.required, Validators.maxLength(50)]],
      lastName: ['', [Validators.required, Validators.maxLength(50)]],
      email: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(254), Validators.email]],
      phone: [],
      activated: [],
      langKey: ['en'],
      authorities: [[], [Validators.required]],
      password: ['', []],
      confirmPassword: ['', []]
    });

    this.userService.authorities().subscribe(authorities => {
      this.authorities = authorities;
    });

    if (this.user && this.user.login) {
      this.btnLabel = 'Update';
      this.selectedAuthority = this.user.authorities[0];
      this.updateForm(this.user);
    } else {
      this.user = new User();
    }
  }


  save(): void {
    this.isSaving = true;
    this.newUser = new User();
    this.updateUser(this.newUser);
    if (this.user.id) {
      this.newUser.id = this.user.id;
      this.userService.update(this.newUser).subscribe(
        () => this.onSaveSuccess(),
        (data) => this.onSaveError(data)
      );
    } else {
      this.newUser.langKey = 'en';
      this.userService.create(this.newUser).subscribe(
        () => this.onSaveSuccess(),
        (data) => this.onSaveError(data)
      );
    }
  }

  private updateForm(user: User): void {
    this.userForm.patchValue({
      id: user.id,
      login: user.login,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      phone: user.phone,
      activated: user.activated,
      langKey: user.langKey,
      authorities: user.authorities,
      password: user.password
    });
  }

  private updateUser(user: User): void {
    user.login = this.userForm.get(['login'])!.value;
    user.firstName = this.userForm.get(['firstName'])!.value;
    user.lastName = this.userForm.get(['lastName'])!.value;
    user.email = this.userForm.get(['email'])!.value;
    user.phone = this.userForm.get(['phone'])!.value;
    user.activated = this.userForm.get(['activated'])!.value;
    user.langKey = this.userForm.get(['langKey'])!.value;
    user.authorities = new Array();
    user.authorities.push(this.userForm.get(['authorities'])!.value);
    user.password = this.userForm.get(['password'])!.value;
  }

  private updateUserOfList(): void {
    this.user.login = this.newUser.login;
    this.user.firstName = this.newUser.firstName;
    this.user.lastName = this.newUser.lastName;
    this.user.email = this.newUser.email;
    this.user.phone = this.newUser.phone;
    this.user.activated = this.newUser.activated;
    this.user.langKey = this.newUser.langKey;
    this.user.authorities = this.newUser.authorities;
  }


  private onSaveSuccess(): void {
    this.updateUserOfList();
    this.isSaving = false;
    this.eventManager.broadcast({
      name: 'userListModification',
      content: 'Changing an user'
    });
    this.modal.destroy();
  }

  private onSaveError(data): void {
    this.isSaving = false;
    this.errorMessage = data.error.title;
    setTimeout(() => {
      this.errorMessage = '';
    }, 3000);
  }

  destroyModal(): void {
    this.modal.destroy();
  }
}
